<template>
  <div class="org-desc">
    <div class="org-detail">
      <div class="org-head">
        <img :src="logo" alt="">
      </div>
      <div class="org-name">{{ name }}</div>
    </div>
    <div class="org-nav">
      <div v-for="item in leftNav" :key="item.active" :class="{active:item.active == active}" class="item"
           @click="go(item.active)">
<!--        <img :src="item.icon" alt="" class="icon">-->
        <i :class="item.iconfont"></i>
        <b>{{ item.name }}</b>
        <img v-if="item.active == active" alt="" class="jiantou" src="@/assets/images/jiantounav.png">
        <el-badge v-if="item.hasApply" value="1" class="badge" is-dot>
        </el-badge>
      </div>
    </div>
  </div>
</template>
<script>
import {get_base_info} from "@/api/admin";

export default {
  name: "leftPage",
  data() {
    return {
      logo: '',
      name: '',
      org_id: '',
      leftNav: []
    }
  },
  props: {
    active: {
      type: [String, Number],
      default: ''
    },
    role: {
      type: [Array],
      default: () => {
        return []
      }
    }
  },
  computed: {},
  components: {},
  created() {
    this.org_id = this.$route.query.org_id
    this.init()
  },
  methods: {

    async init() {
      let _data = await get_base_info(this.org_id);
      this.logo = _data.data.logo
      this.name = _data.data.org_name
    },

    go(active) {
      this.$emit("tabChange", active)
    },
  },
  watch: {
    role() {
      let _menus = [
        {
          name: '基础信息',
          icon: require('@/assets/images/left-jichuxinxi.png'),
          iconfont: 'iconfont icon-zhengxinxinxi',
          active: 1,
          hasApply: 0,
        },
        {
          name: '资金监管信息',
          icon: require('@/assets/images/left-zijinjianguanxinxi.png'),
          iconfont: 'iconfont icon-zijinjianguan',
          active: 2,
          hasApply: 0,
        },
        {
          name: '机构运营信息',
          icon: require('@/assets/images/left-jigouyunyingxinxi.png'),
          iconfont: 'iconfont icon-yunyingfenxi',
          active: 3,
          hasApply: 0,
        },
        {
          name: '闭店申请信息',
          icon: require('@/assets/images/left-jigouyunyingxinxi.png'),
          iconfont: 'iconfont icon-wodeshensu',
          active: 4,
          hasApply: 0,
        },
      ]
      _menus.map(item => {
        item.hasApply = this.role.includes(item.active)
      })
      this.leftNav = _menus
    }
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.org-desc {
  min-height: calc(100vh - (173px + 199px));
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  height: 100%;
  width: 280px;

  .org-nav {
    flex: 1;
    width: 100%;
    //background: #2791ff;
    background-image: linear-gradient(0deg,
      #7eb6ff 0%,
      #2791ff 100%);
    border-radius: 10px;
    margin-top: 20px;

    .item {
      width: 100%;
      height: 100px;
      border-bottom: 1px solid rgba(255, 255, 255, .4);
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      cursor: pointer;

      &.active {
        background: rgba(255, 255, 255, .25);
      }

      .icon {
        margin-right: 15px;
      }
      .iconfont {
        margin-right: 15px;
        font-size: 30px;
        color: #ffffff;
      }

      b {
        font-weight: normal;
        font-size: 20px;
        color: #ffffff;
        width: 120px;
      }

      .jiantou {
        position: absolute;
        top: 45px;
        right: -8px;
      }
    }
  }

  .org-detail {
    width: 100%;
    height: 220px;
    background-color: #2791ff;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 20px;

    .org-name {
      width: 100%;
      text-align: center;
      font-size: 18px;
      color: #ffffff;
      padding-top: 15px;
    }

    .org-head {
      width: 68px;
      height: 68px;
      border-radius: 34px;
      margin: 0 auto;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>


